import { connect } from 'react-redux';
import { DownloadKnowledgeButtonComponent } from './download-knowledge-button.component';
import { getLang } from 'shared/store/selectors/lang.selector';

const mapStateToProps = state => ({
  lang: getLang('ACTION_BUTTON_TOOLTIPS')(state),
});

export const DownloadKnowledgeButton = connect(mapStateToProps)(DownloadKnowledgeButtonComponent);
